import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router';
import { ErrorBoundaryWrapper } from '@/features/api/components/ErrorBoundaryWrapper';
import { LoginGuard } from '@/features/auth/components/LoginGuard';
import { useMixpanel } from '@/hooks/useMixpanel';
import { initBugsnag } from '@/libs/bugsnag';
import { initMixpanel } from '@/libs/mixpanel';
import packageJson from '../../package.json';
import { AppRoutes } from './AppRoutes';

const queryClient = new QueryClient();

// error tracking init
initBugsnag();

export default function App() {
  const mixpanelTokenFromEnv = import.meta.env.VITE_MIXPANEL_TOKEN;
  const isDev = import.meta.env.DEV;
  const setMixpanel = useMixpanel((state) => state.setMixpanel);

  useEffect(() => {
    const mixpanel = initMixpanel(mixpanelTokenFromEnv, 'electra-spot-on', isDev);
    setMixpanel(mixpanel, {
      app_version: packageJson.version,
    });
  }, [setMixpanel]);

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />

      <BrowserRouter>
        <LoginGuard>
          <ErrorBoundaryWrapper>
            <AppRoutes />
          </ErrorBoundaryWrapper>
        </LoginGuard>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
